import { render, staticRenderFns } from "./StatusesSummaries.vue?vue&type=template&id=0a1794cc&scoped=true&"
import script from "./StatusesSummaries.vue?vue&type=script&lang=ts&"
export * from "./StatusesSummaries.vue?vue&type=script&lang=ts&"
import style0 from "./StatusesSummaries.vue?vue&type=style&index=0&id=0a1794cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1794cc",
  null
  
)

export default component.exports